// Debug utility fonksiyonları

export const loadingDebugger = {
  logs: [],
  
  log: (component, action, details = {}) => {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      component,
      action,
      details,
      id: Math.random().toString(36).substr(2, 9)
    };
    
    loadingDebugger.logs.push(logEntry);
    
    // Son 100 log'u tut
    if (loadingDebugger.logs.length > 100) {
      loadingDebugger.logs = loadingDebugger.logs.slice(-100);
    }
    return logEntry;
  },
  
  logError: (component, error, context = {}) => {
    return loadingDebugger.log(component, 'ERROR', {
      error: error.message || error,
      stack: error.stack,
      context
    });
  },
  
  logTimeout: (component, operation, timeout) => {
    return loadingDebugger.log(component, 'TIMEOUT', {
      operation,
      timeout,
      userAgent: navigator.userAgent,
      connection: navigator.connection?.effectiveType || 'unknown'
    });
  },
  
  logLoadingStart: (component, operation) => {
    return loadingDebugger.log(component, 'LOADING_START', {
      operation,
      timestamp: Date.now()
    });
  },
  
  logLoadingEnd: (component, operation, success = true, duration) => {
    return loadingDebugger.log(component, 'LOADING_END', {
      operation,
      success,
      duration,
      timestamp: Date.now()
    });
  },
  
  getReport: () => {
    const now = Date.now();
    const last5Minutes = loadingDebugger.logs.filter(
      log => (now - new Date(log.timestamp).getTime()) < 5 * 60 * 1000
    );
    
    const errors = last5Minutes.filter(log => log.action === 'ERROR');
    const timeouts = last5Minutes.filter(log => log.action === 'TIMEOUT');
    const loadings = last5Minutes.filter(log => 
      log.action === 'LOADING_START' || log.action === 'LOADING_END'
    );
    
    return {
      summary: {
        totalLogs: loadingDebugger.logs.length,
        last5MinutesLogs: last5Minutes.length,
        errorCount: errors.length,
        timeoutCount: timeouts.length,
        loadingOperations: loadings.length
      },
      errors,
      timeouts,
      loadings,
      allLogs: loadingDebugger.logs
    };
  },
  
  clear: () => {
    loadingDebugger.logs = [];
    console.log('Loading debug logs cleared');
  },
  
  exportLogs: () => {
    const report = loadingDebugger.getReport();
    const dataStr = JSON.stringify(report, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `loading-debug-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

// Performance monitoring
export const performanceMonitor = {
  measure: (name, fn) => {
    return async (...args) => {
      const startTime = performance.now();
      loadingDebugger.logLoadingStart('PerformanceMonitor', name);
      
      try {
        const result = await fn(...args);
        const endTime = performance.now();
        const duration = endTime - startTime;
        
        loadingDebugger.logLoadingEnd('PerformanceMonitor', name, true, duration);
        
        if (duration > 5000) {
          loadingDebugger.log('PerformanceMonitor', 'SLOW_OPERATION', {
            operation: name,
            duration,
            warning: 'Operation took longer than 5 seconds'
          });
        }
        
        return result;
      } catch (error) {
        const endTime = performance.now();
        const duration = endTime - startTime;
        
        loadingDebugger.logLoadingEnd('PerformanceMonitor', name, false, duration);
        loadingDebugger.logError('PerformanceMonitor', error, { operation: name });
        
        throw error;
      }
    };
  }
};

// Global error handler
window.addEventListener('error', (event) => {
  loadingDebugger.logError('Global', event.error, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  });
});

window.addEventListener('unhandledrejection', (event) => {
  loadingDebugger.logError('Global', event.reason, {
    type: 'unhandledrejection'
  });
});

// Development modunda debug paneli ekle
if (import.meta.env.DEV) {
  window.loadingDebugger = loadingDebugger;
  window.performanceMonitor = performanceMonitor;
  
  console.log('🐛 Loading Debug Utilities Available:');
  console.log('- window.loadingDebugger.getReport() - Get debug report');
  console.log('- window.loadingDebugger.exportLogs() - Export logs to file');
  console.log('- window.loadingDebugger.clear() - Clear all logs');
} 